@if (backupModel && backupModel.id > 0) {
    <div class="detail-page-summary">
        <div class="row">
            <div class="col-6">
                <div class="property"><b>ID:</b> {{ backupModel.identifier }}</div>
                <div class="property text-truncate"><b>Name:</b> {{ backupModel.name }}</div>
            </div>
            <div class="col-6">
                <div class="property"><b>Last modifier:</b> {{ backupModel.lastModifier }}</div>
                <div class="property"><b>Creator:</b> {{ backupModel.creator }}</div>
            </div>
        </div>
    </div>
}

@if (formGroup) {
    <div class="detail-page-card" [formGroup]="formGroup" data-uiid="task-series-detail-form">
        <div class="detail-page-card-title">{{ 'defineAndManage' | t }}</div>
        <div class="detail-page-card-body padded form-group-styling cerrix-task-series-sm">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group">
                        <cerrix-textfield
                            [fieldLabel]="'name' | t"
                            dataUiid="task-series-detail-name"
                            identifier="taskSeriesNameInput"
                            formControlName="name"
                            [placeholder]="'requiredPlaceholder' | t"
                        ></cerrix-textfield>
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="form-group">
                        <label>{{ 'taskType' | t }}</label>
                        <ng-select
                            data-uiid="task-series-linked-type"
                            name="linkedTypes"
                            [multiple]="true"
                            [items]="linkedTypes"
                            [placeholder]="'requiredPlaceholder' | t"
                            formControlName="linkedTypes"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group col">
                        <label for="responsibleSelect">{{ 'responsibles' | t }}</label>
                        <ng-select
                            data-uiid="task-series-responsible"
                            name="responsibleSelect"
                            [multiple]="true"
                            [items]="validResponsibles"
                            [placeholder]="'requiredPlaceholder' | t"
                            formControlName="responsibleIds"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="form-group col">
                        <label for="reviewersSelect">{{ 'reviewers' | t }}</label>
                        <i
                            class="far fa-info-circle mx-2"
                            [matTooltip]="'reviewersTooltip' | t"
                        ></i>
                        <ng-select
                            data-uiid="task-series-reviewers"
                            name="reviewersSelect"
                            [multiple]="true"
                            [items]="validReviewers"
                            formControlName="reviewerIds"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group col">
                        <label for="notificationPeriodSelect">{{ 'notifications' | t }}</label>
                        <ng-select
                            data-uiid="task-series-notification"
                            name="notificationPeriodSelect"
                            [multiple]="true"
                            [items]="validNotificationPeriods"
                            formControlName="notificationPeriodIds"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="form-group col">
                        <label for="scoreOptionsSelect">{{ 'taskScoreOption' | t }}</label>
                        <i
                            class="far fa-info-circle mx-2"
                            [matTooltip]="'taskScoreTooltip' | t"
                        ></i>
                        <ng-select
                            data-uiid="task-series-score-options"
                            name="scoreOptionsSelect"
                            [multiple]="false"
                            [items]="taskScoreOptions"
                            formControlName="taskScoreOption"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="true"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col">
                    <cerrix-textarea
                        [fieldLabel]="'description' | t"
                        dataUiid="task-series-detail-description"
                        identifier="taskSeriesExecutionDescriptionInput"
                        [rows]="4"
                        formControlName="description"
                    ></cerrix-textarea>
                </div>
            </div>
        </div>
        <div class="detail-page-card">
            <div class="detail-page-card-title-with-subtext">{{ 'planning' | t }}</div>
            @if (model.id > 0) {
                <div class="detail-page-card-subtext">
                    {{ 'planningSubtext' | t }}
                </div>
            }
            <div class="detail-page-card-body padded form-group-styling cerrix-task-series-sm">
                <div class="row">
                    <cerrix-recurrence
                        [parentForm]="formGroup"
                        [model]="recurrenceViewModel"
                        [disableAllExcept]="recurrenceViewModel?.id > 0 ? ['enddate'] : []"
                        #recurrenceComponent
                    ></cerrix-recurrence>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'details' | t }}</div>
        <div class="detail-page-card-body padded cerrix-taskSeries-sm">
            <div class="fancy-loader submodule"></div>
        </div>
    </div>
}
